import styled, { css } from "styled-components";

export const Badge = styled.button`
  background: none;
  border: 0;
  position: relative;
  .bad {
    ${(props) =>
      props.hasUnread &&
      css`
        &::after {
          position: absolute;
          right: 2px;
          top: 2px;
          width: 8px;
          height: 8px;
          border: 1px solid white;
          background: #0d6efd;
          content: "";
          border-radius: 50%;
        }
      `}
  }
`;
